<form [formGroup]="htmlForm!" novalidate>
    <editor
        apiKey="x7ek8y038q71miieruxssynb2plbuqp4kfd0fmpkfltgok7n"
        cloudChannel="7"
        [disabled]="false"
        id=""
        [init]="{
        plugins: 'lists link image paste help wordcount',
        toolbar:
            'undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help | image'
    }"
        initialValue=""
        [inline]="false"
        plugins=""
        tagName="div"
        toolbar=""
        formControlName="html"
        [(ngModel)]="html"
        selector="textarea"
    ></editor>
</form>
